import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { sessions } from "../common/localstorage/SessionStorage";
import { DecodeToken } from "../features/login/models";

const useIsAdmin = () => {
  useEffect(() => {
    // Function to check token expiration
    const checkingIfLoggedInIsApplicant = () => {
      const token = sessions.getToken(); // Retrieve the token

      if (token) {
        const decoded = jwtDecode<DecodeToken>(token); // Decode token

        if (decoded.roles) {
          if (!decoded.roles.includes("Admin")) {
            sessions.removeToken(); // Remove token
            window.location.replace("/login"); // Redirect to login
          }
        }
      } else {
        sessions.removeToken(); // Remove token
        window.location.replace("/login"); // Redirect to login
      }
    };

    // Initial check when component mounts
    checkingIfLoggedInIsApplicant();

    // Set interval to regularly check token expiration (e.g., every minute)
    const intervalId = setInterval(() => {
      checkingIfLoggedInIsApplicant();
    }, 60000); // 60000 ms = 1 minute

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);
};

export default useIsAdmin;
